import { render, staticRenderFns } from "./loginVip.vue?vue&type=template&id=6a36d444&scoped=true&"
import script from "./loginVip.vue?vue&type=script&lang=js&"
export * from "./loginVip.vue?vue&type=script&lang=js&"
import style0 from "./loginVip.vue?vue&type=style&index=0&id=6a36d444&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36d444",
  null
  
)

export default component.exports